import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'

export const UnderlineText = (props) => {
  const { text, color, onClick, cursor } = props
   const UnderlineText = styled(Typography)(() => (({
      color: color,
      cursor: cursor && 'pointer',
      textDecoration: 'underline',
    })))
  return (
   <UnderlineText m={1} variant="caption" component="p" textAlign="center" onClick={onClick}>{ text }</UnderlineText>
  )
}
